window._ = require('lodash');
window.axios = require('axios');

const trimTrailingSlash = (value) => (value ? value.replace(/\/+$/, '') : value);

const isLocalDevHost = (hostname) =>
  hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';

const fallbackHostConfig = (() => {
  const { protocol, host, hostname } = window.location;

  if (isLocalDevHost(hostname)) {
    return {
      apiUrl: `${protocol}//${host}/api`,
      appUrl: `${protocol}//${host}`,
    };
  }

  if (window.location.hostname === 'zoopup.com') {
    return {
      apiUrl: 'https://zoopup.com/api',
      appUrl: 'https://zoopup.com',
    };
  }

  if (window.location.hostname === 'staging.zoopup.com') {
    return {
      apiUrl: 'https://staging.zoopup.com/api',
      appUrl: 'https://staging.zoopup.com',
    };
  }

  return {
    apiUrl: 'http://13.233.163.65/api',
    appUrl: 'http://13.233.163.65',
  };
})();

const frontendConfig = {
  apiUrl: trimTrailingSlash(process.env.MIX_API_URL || fallbackHostConfig.apiUrl),
  appUrl: trimTrailingSlash(process.env.MIX_APP_URL || fallbackHostConfig.appUrl || window.location.origin),
  loginUrl: process.env.MIX_LOGIN_URL || '/accountlogin',
  pusherKey: process.env.MIX_PUSHER_APP_KEY || '6252cad59bcb7e5adf5d',
  pusherCluster: process.env.MIX_PUSHER_APP_CLUSTER || 'ap2',
};

window.axios.defaults.baseURL = frontendConfig.apiUrl;
window.hostname = frontendConfig.appUrl;
window.zoopupConfig = frontendConfig;
// set for common.js variable function baseurl()
window.axios.defaults.withCredentials = true;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Restore Bearer token early so admin SSO API calls are authenticated
// before Vuex initializeAppContext runs.
const existingToken = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
if (existingToken) {
  window.axios.defaults.headers.common['Authorization'] = `Bearer ${existingToken}`;
}

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const status = error.response.status;
      const data = error.response.data || {};
      const hasFieldErrors = !!(data.error || data.errors);

      if (status === 401) {
        Vue.prototype.$Notice.error({
          title: "Unauthorized",
          desc: "Your session has expired. Redirecting to login...",
        });
        const onAdmin =
          window.location.pathname.startsWith('/admin') ||
          (error.config && error.config.url && String(error.config.url).includes('/admin/'));
        window.location.href = onAdmin ? '/admin' : frontendConfig.loginUrl;
      } else if (status === 429) {
        Vue.prototype.$Notice.error({
          title: "Too many requests",
          desc:
            (data && data.message) ||
            "Too many requests. Please wait a moment and try again.",
        });
      } else if (status >= 500 && !hasFieldErrors) {
        // Skip generic toast when API already returned field validation errors.
        Vue.prototype.$Notice.error({
          title: "Server Error",
          desc: "Something went wrong. Please try again.",
        });
      }
    } else {
      Vue.prototype.$Notice.error({
        title: "Network Error",
        desc: "Unable to reach the server. Please check your connection.",
      });
    }
    return Promise.reject(error);
  }
);

import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');
window.Echo = new Echo({
  broadcaster: 'pusher',
  key: frontendConfig.pusherKey,
  cluster: frontendConfig.pusherCluster,
  forceTLS: true
});